import { Input } from '../../../common/input/Input';
import { Select } from '../../../common/select/Select';
import { ACTIVITY_LEVEL_OPTIONS, BIOLOGICAL_SEX_OPTIONS, GOAL_OPTIONS } from '../mealPlannerOptions';

export const GoalsStep = ({ goal, bodyStats, onGoalChange, onBodyStatsChange }) => {
  const setStat = (name, value) => onBodyStatsChange({ ...bodyStats, [name]: value });

  return (
    <div className="meal-planner-step">
      <h2 className="meal-planner-step__title">What's your goal?</h2>
      <p className="meal-planner-step__sub">This decides your daily calorie and macro targets.</p>

      <div className="meal-planner-step__goal-cards">
        {GOAL_OPTIONS.map((option) => (
          <button
            key={option.value}
            type="button"
            className={`meal-planner-step__goal-card${goal === option.value ? ' active' : ''}`}
            onClick={() => onGoalChange(option.value)}
          >
            {option.label}
          </button>
        ))}
      </div>

      <div className="meal-planner-step__body-stats">
        <Input
          label="Weight (kg)"
          type="number"
          name="weightKg"
          value={bodyStats.weightKg ?? ''}
          onChange={({ value }) => setStat('weightKg', value)}
        />
        <Input
          label="Height (cm)"
          type="number"
          name="heightCm"
          value={bodyStats.heightCm ?? ''}
          onChange={({ value }) => setStat('heightCm', value)}
        />
        <Input
          label="Age"
          type="number"
          name="age"
          value={bodyStats.age ?? ''}
          onChange={({ value }) => setStat('age', value)}
        />
        <Select
          showLabel
          label="Biological Sex"
          placeholder="Select"
          options={BIOLOGICAL_SEX_OPTIONS}
          value={bodyStats.biologicalSex ?? ''}
          onChange={(e) => setStat('biologicalSex', e.target.value)}
        />
        <Select
          showLabel
          label="Activity Level"
          placeholder="Select"
          options={ACTIVITY_LEVEL_OPTIONS}
          value={bodyStats.activityLevel ?? ''}
          onChange={(e) => setStat('activityLevel', e.target.value)}
        />
      </div>
    </div>
  );
};
